import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {StartupService} from "../../../../service-ui/startup.service";
import {ProjectService} from "../../../../service-data/project.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {modernDialogConfig} from "../../../../service-ui/dialog-config";
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {LanguagePipe} from "../../../../pipe/language.pipe";
import {Project} from "../../../../../model/Project";
import {Draft} from "../../../../../model/Draft";
import {Book} from "../../../../../model/Book";
import {MoveProjectComponent} from "../dialogs/move-project/move-project.component";
import {Item} from "../../../../../model/cart/Item";
import {ProductService} from "../../../../service-data/product.service";
import {ResourceService} from "../../../../service-data/resource.service";
import {DraftService} from "../../../../service-data/draft.service";
import {BookService} from "../../../../service-data/book.service";
import {PaperTypeService} from "../../../../service-data/paper-type.service";
import {ReasignDraftComponent} from "../dialogs/reasign-draft/reasign-draft.component";
import {ReasignBookComponent} from "../dialogs/reasign-book/reasign-book.component";
import {Resource} from "../../../../../model/Resource";
import {ResourceStatus} from "../../../../service-ui/resource-status";
import {CoverService} from "../../../../service-data/cover.service";
import {BodyService} from "../../../../service-data/body.service";
import {AlertService} from "../../../../service-ui/alert.service";

@Component({
  selector: 'app-classic-project-thumbnail',
  templateUrl: './classic-project-thumbnail.component.html',
  styleUrls: ['./classic-project-thumbnail.component.css']
})
export class ClassicProjectThumbnailComponent implements OnInit, OnChanges {
  @ViewChild('draftCoverImage', { static: true }) draftCoverImage;
  @Input() project: Project;
  @Input() showOnlyPrimary: boolean;
  @Input() projects: Project[];
  @Output() selectedItem = new EventEmitter<Project | Draft | Book>();
  @Output() editingDetailsChange = new EventEmitter<string>();
  @ViewChild('placeHolderProjectName') placeHolderProjectName;
  /** The inline title editor, present only while 'editingTitle'. */
  @ViewChild('titleInput') titleInput;


  displayScale = 1.0;

  renameProject = false;
  editingTitle = false;

  Math = Math;
  public renameDraft: boolean = false;

  /** True while an "Add a Draft" create is in flight — blocks double submits. */
  creatingDraft = false;

  private requestedResources = new Set<number>();

  constructor(public router: Router, public startupService: StartupService, private projectService: ProjectService, private productService: ProductService, public resourceService: ResourceService, public dialog: MatDialog, private draftService: DraftService, private bookService: BookService, public paperTypeService: PaperTypeService, private coverService: CoverService, private bodyService: BodyService, private snackBar: MatSnackBar, private alertService: AlertService) {
  }

  ngOnInit() {
    // this.refreshImagePosition();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('Change ', changes);
    // this.refreshImagePosition();
  }

  /**
   * Emit the Draft / Book itself, not its Project.
   *
   * This tile lists every Draft and Book in the Project, but the detail pane
   * used to render `selectedItem.primaryDraft` / `.primaryBook` - so opening
   * any non-primary row silently showed the primary one instead.
   * `ProjectsComponent.selectedItemChanged` unpacks the union and still keeps
   * a Project in `selectedItem` for the grid.
   */
  openDraft(draft: Draft) {
    this.selectedItem.emit(draft);
    this.editingDetailsChange.emit('DRAFT');
  }

  openBook(book: Book) {
    this.selectedItem.emit(book);
    this.editingDetailsChange.emit('BOOK');
  }

  // viewProject(project: Project, viewType: string): void {
  //   this.selectedItem.emit(project);
  //   this.editingDetailsChange.emit(viewType);
  // }
  //

  // renameProject(project: Project): void {
  //   const dialogConfig = modernDialogConfig();
  //   dialogConfig.width = '640px';
  //   dialogConfig.disableClose = false;
  //   dialogConfig.data = { organization: this.startupService.getCurrentOrganization(), project: project };
  //   const dialogRef = this.dialog.open(MoveProjectComponent, dialogConfig);
  // }

  moveProject(project: Project): void {
    const dialogConfig = modernDialogConfig({ width: '640px' });
    dialogConfig.data = { organization: this.startupService.getCurrentOrganization(), project: project };
    const dialogRef = this.dialog.open(MoveProjectComponent, dialogConfig);
  }

  /**
   * Create an empty Draft inside this Project and open it.
   *
   * The Draft is created with its DraftBody and DraftCover in one
   * call — see `DraftService.createDraftInProject` for why that
   * nesting is required rather than convenient.
   *
   * Two things are deliberate here:
   *
   * - **The response is checked for an `ID`.** `AbstractLiveDataService`
   *   funnels HTTP failures through `handleError`, which returns
   *   `of(undefined)` — so a rejected or failed create arrives at
   *   `subscribe` looking exactly like a successful one. Server-side,
   *   `Drafts.add` also rejects any role that is not `organization` by
   *   returning an empty row rather than an error status. Without this
   *   check both cases would silently report success and leave the
   *   operator looking for a Draft that does not exist.
   *
   * - **The new Draft is only opened when it becomes the primary one.**
   *   The detail pane renders `selectedItem.primaryDraft`, so opening a
   *   Project whose primary Draft is a different one would show the
   *   wrong Draft. When the Project already has a primary we leave it
   *   alone and just report that the Draft was added.
   */
  addDraft(project: Project): void {
    if ( this.creatingDraft || !project ) {
      return;
    }
    const organization = this.startupService.getCurrentOrganization();
    if ( !organization || !organization.ID ) {
      this.snackBar.open(LanguagePipe.get('The Draft could not be created.'),
        LanguagePipe.get('Dismiss', 'compressSpaces'), { duration: 6000 });
      return;
    }

    this.creatingDraft = true;
    const becomesPrimary = !project.primaryDraft;
    this.draftService.createDraftInProject(organization.ID, project.ID, project.name).subscribe(
      draft => {
        this.creatingDraft = false;
        if ( !draft || !draft.getId() ) {
          console.error('addDraft: create returned no Draft', draft);
          this.snackBar.open(LanguagePipe.get('The Draft could not be created.'),
            LanguagePipe.get('Dismiss', 'compressSpaces'), { duration: 6000 });
          return;
        }

        // Link locally so the tile updates now rather than whenever the
        // notification round-trip lands.
        if ( !project.drafts ) { project.drafts = []; }
        if ( !project.drafts.some(d => d && d.getId() === draft.getId()) ) {
          project.drafts.push(draft);
        }
        draft.project = project;

        if ( becomesPrimary ) {
          project.primaryDraft = draft;
          (project as any).primaryDraft_ID = draft.getId();
          this.projectService.setDraftAsPrimary(project.ID, draft.getId()).subscribe();
          this.selectedItem.emit(project);
          this.editingDetailsChange.emit('DRAFT');
        } else {
          this.snackBar.open(LanguagePipe.get('Draft added'),
            LanguagePipe.get('Dismiss', 'compressSpaces'), { duration: 4000 });
        }
      },
      err => {
        this.creatingDraft = false;
        console.error('addDraft: create failed', err);
        this.snackBar.open(LanguagePipe.get('The Draft could not be created.'),
          LanguagePipe.get('Dismiss', 'compressSpaces'), { duration: 6000 });
      }
    );
  }

  deleteProject (project: Project): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        name: project.name,
        title: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + project.name + LanguagePipe.get('?', 'compressSpaces'),
        body: '', // LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.name + LanguagePipe.get('?', 'compressSpaces'),
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + project.name,
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed. result[' + result + ']');
      if ( result && result === 'ok' ) {
        // this.draftService.deleteDraft(draft).then( proj => {
        //   console.log('Deleted a draft');
        // });
      }
    });

  }

  makePrimaryDraft(draft: Draft, element: any) {
    element.classList.add('spinner');
    this.projectService.setDraftAsPrimary(draft.project.ID, draft.ID).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  makeBook(draft: Draft, element: any) {
    element.classList.add('spinner');
    this.projectService.makeDraftIntoBook(draft.ID, false).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  copyDraft(draft: Draft, element: any) {
    element.classList.add('spinner');
    this.draftService.copy(draft.ID).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  deleteDraft(draft: Draft, element: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        name: draft.title,
        title: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.title + LanguagePipe.get('?', 'compressSpaces'),
        body: '',
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Delete', 'compressSpaces') + ' ' + draft.title,
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed. result[' + result + ']');
      if (result && result === 'ok') {
        element.classList.add('spinner');
        this.draftService.deleteItem(draft).subscribe( proj => {
          element.classList.remove('spinner');
          console.log('Deleted a draft');
        });
      }
    });
  }

  createNewProjectWithDraft(draft: Draft, element: any) {
    element.classList.add('spinner');
    this.projectService.createNewProjectWithDraft(draft.ID, draft.title).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  changeProjectForDraft(draft: Draft, element: any) {
    const dialogConfig = modernDialogConfig({ width: '640px' });
    dialogConfig.data = { draft: draft, projects: this.projectService.objects, folders: this.startupService.getCurrentOrganization().getProjectFolders() };
    const dialogRef = this.dialog.open(ReasignDraftComponent, dialogConfig);
  }

  makePrimaryBook(book: Book, element: any) {
    element.classList.add('spinner');
    this.projectService.setBookAsPrimary(book.project.ID, book.ID).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  makeDraft(book: Book, element: any) {
    element.classList.add('spinner');
    this.projectService.makeBookIntoDraft(book.ID, false).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  archiveBook(book: Book, element: any): void {
    element.classList.add('spinner');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: {
        name: book.title,
        title: LanguagePipe.get('Archive', 'compressSpaces') + ' ' + book.title + LanguagePipe.get('?', 'compressSpaces'),
        body: '',
        noButton: LanguagePipe.get('Cancel', 'compressSpaces'),
        yesButton: LanguagePipe.get('Archive', 'compressSpaces') + ' ' + book.title,
        returnValue: 'ok'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === 'ok') {
        this.bookService.archive(book.ID).subscribe( proj => {
          element.classList.remove('spinner');
          console.log('Deleted a book');
        });
      } else {
        element.classList.remove('spinner');
      }
    });
  }

  createNewProjectWithBook(book: Book, element: any) {
    element.classList.add('spinner');
    // Must be createNewProjectWithBook, not ...WithDraft. This used to call the
    // Draft endpoint with a Book id: the server then looked the id up in the
    // `draft` table, where it either missed entirely or — worse — hit an
    // unrelated Draft that happened to share the number and moved *that* into a
    // brand new Project. `ProjectDetailsComponent` always called the right one,
    // so the same button behaved differently depending on which screen it was
    // pressed from.
    this.projectService.createNewProjectWithBook(book.ID, book.title).subscribe( x => {
      element.classList.remove('spinner');
    });
  }

  changeProjectForBook(book: Book, element: any) {
    const dialogConfig = modernDialogConfig({ width: '640px' });
    dialogConfig.data = { book: book, projects: this.projectService.objects, folders: this.startupService.getCurrentOrganization().getProjectFolders() };
    const dialogRef = this.dialog.open(ReasignBookComponent, dialogConfig);
  }

  /**
   * A Book is ordered through its Product, so a Book with no Product row
   * cannot be added to the cart at all. That case used to fall out of the loop
   * and do nothing: the menu closed, the cart did not change, and nothing said
   * why. Tell the operator rather than failing silently.
   */
  addBookToCart(book: Book) {
    for (const product of this.productService.objects ) {
      if ( product.book_ID === book.ID) {
        const item: Item = this.startupService.getCart().addProductItem(product, 1);
        return;
      }
    }
    this.alertService.error(LanguagePipe.get('No product found for this book', 'compressSpaces'));
  }

  addDraftToCart(draft: Draft) {
    if ( draft ) {
      this.startupService.getCart().addDraftItem(draft, 1);
    }
  }

  isProjectNameUsed(): boolean {
    if ( !this.placeHolderProjectName || !this.placeHolderProjectName.nativeElement || !this.placeHolderProjectName.nativeElement.value ) {
      return true;
    }
    const newProductName = this.placeHolderProjectName.nativeElement.value.trim();

    for ( const project of this.projects ) {
      if ( newProductName === project.name ) {
        return true;
      }
    }
    return false;
  }

  saveProjectName(element: any) {
    element.classList.add('spinner');
    console.log('Save Project Name' + this.placeHolderProjectName.nativeElement.value);
    this.project.name = this.placeHolderProjectName.nativeElement.value;
    this.projectService.updateItem(this.project).subscribe( proj => {
      element.classList.remove('spinner');
    });
  }

  cancelProjectName() {
    this.placeHolderProjectName.nativeElement.value = this.project.name;
  }

  /**
   * Rename from the overflow menu.
   *
   * Focus has to be applied in a setTimeout: the input does not exist
   * until Angular has re-rendered the *ngIf this flag controls.
   *
   * 'startEditTitle' finds the same input by walking up from its own
   * event target, which a menu click cannot do — mat-menu renders its
   * panel in an overlay at the end of the body, nowhere near
   * '.pt-title-bar'. Hence the ViewChild.
   */
  startRename(): void {
    this.editingTitle = true;
    setTimeout(() => {
      const input = this.titleInput && this.titleInput.nativeElement;
      if ( input ) { input.focus(); input.select(); }
    });
  }

  startEditTitle(event: Event) {
    event.stopPropagation();
    this.editingTitle = true;
    setTimeout(() => {
      const input = (event.target as HTMLElement).closest('.pt-title-bar')?.querySelector('.pt-title-input') as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
    });
  }

  commitTitle(value: string) {
    const trimmed = value.trim();
    this.editingTitle = false;
    if (trimmed && trimmed !== this.project.name) {
      this.project.name = trimmed;
      this.projectService.updateItem(this.project).subscribe();
    }
  }

  cancelTitle(input: HTMLInputElement) {
    input.value = this.project.name || '';
    this.editingTitle = false;
  }

  get sortedDrafts(): Draft[] {
    if (!this.project || !this.project.drafts) {
      return [];
    }
    const items = this.project.drafts.filter(d => (!this.showOnlyPrimary) || (this.project.primaryDraft && d.ID === this.project.primaryDraft.ID));
    return items.sort((a, b) => {
      if (this.project.primaryDraft) {
        if (a.ID === this.project.primaryDraft.ID) {
          return -1;
        }
        if (b.ID === this.project.primaryDraft.ID) {
          return 1;
        }
      }
      return new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime();
    });
  }

  get sortedBooks(): Book[] {
    if (!this.project || !this.project.books) {
      return [];
    }
    // Archived Books stay in the client cache to resolve
    // historical Order / Package references but are deliberately
    // hidden from the Projects UI â€” this thumbnail represents the
    // active catalogue, and an archived Book is by definition
    // retired from active use. Filtering here means neither the
    // sub-item list nor any downstream template consumer of
    // `sortedBooks` (e.g. the first-book difference comparisons
    // in the drafts strip) will surface archived rows.
    const active = this.project.books.filter(b => b && String((b as any).archived || '').toUpperCase() !== 'TRUE');
    const items = active.filter(b => (!this.showOnlyPrimary) || (this.project.primaryBook && b.ID === this.project.primaryBook.ID));
    return items.sort((a, b) => {
      if (this.project.primaryBook) {
        if (a.ID === this.project.primaryBook.ID) {
          return -1;
        }
        if (b.ID === this.project.primaryBook.ID) {
          return 1;
        }
      }
      return new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime();
    });
  }

  getDaysOldString(date: Date | string): string {
    const days = this.getDaysOld(date);
    if (days > 365) {
      const y = Math.floor(days / 365);
      const d = days % 365;
      return y + 'y ' + d + 'd';
    }
    return days + 'd';
  }

  getDaysOld(date: Date | string): number {
    if (!date) {
      return 0;
    }
    const now = new Date().getTime();
    const then = new Date(date).getTime();
    return Math.floor((now - then) / (1000 * 60 * 60 * 24));
  }

  formatTrim(width: number, height: number): string {
    if (!width || !height) {
      return '';
    }
    return this.localizeNumber((Math.round((width / 72) * 100) / 100)) + 'x' + this.localizeNumber((Math.round((height / 72) * 100) / 100));
  }

  formatShift(shift: number): string {
    if (shift == null || shift === undefined) {
      return this.localizeNumber('0.00');
    }
    return this.localizeNumber((Math.round((shift / 72) * 100) / 100).toFixed(2));
  }

  formatScale(scale: number): string {
    if (scale == null || scale === undefined) {
      return this.localizeNumber('100') + '%';
    }
    return this.localizeNumber((Math.round(scale * 100))) + '%';
  }

  /** Transform digits to locale-specific characters (e.g., Arabic-Indic numerals) */
  localizeNumber(value: any): string {
    return LanguagePipe.localizeNumber(value);
  }

  // getResourceStatusIcon(resource_ID: number): string {
  //   if (!resource_ID) {
  //     return '';
  //   }
  //   const res = this.resourceService.objects.find(r => r.ID === resource_ID);
  //   if (!res) {
  //     if (!this.requestedResources.has(resource_ID)) {
  //       this.requestedResources.add(resource_ID);
  //       this.resourceService.getItem(resource_ID).subscribe();
  //     }
  //     return 'help_outline'; // unknown
  //   }
  //   switch (res.prepared) {
  //     case 'COMPLETE': return 'check_circle';
  //     case 'ERROR': return 'error';
  //     case 'INITIAL':
  //     case 'WAITING':
  //     case 'IN_PROGRESS': return 'hourglass_empty';
  //     default: return 'help_outline';
  //   }
  // }

  // --- Resource id badge -------------------------------------------
  // Takes the SIDE object so the same four methods serve both the Draft
  // rows (draftCover / draftBody - no `standardized` field) and the Book
  // rows (cover / body - has one). See
  // src/app/service-ui/resource-status.ts.

  getResourceStatusColor(side: any): string {
    return ResourceStatus.fill(!!(side && side.resource_ID), this.resourceFor(side && side.resource_ID));
  }

  /**
   * Bottom stripe encoding `standardized`.
   *
   * Resolves to `'none'` for the Draft rows, which have no such field -
   * so the Draft and Book badges in this side-by-side view stay
   * directly comparable on the fill colour, and the stripe only appears
   * where there is a second stage to report.
   */
  getResourceStripe(side: any): string {
    return ResourceStatus.stripe(this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  isResourceActionable(side: any): boolean {
    return ResourceStatus.isActionable(this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  getResourceDisplayString(side: any): string {
    return ResourceStatus.displayString(side && side.resource_ID);
  }

  getResourceHoverText(side: any, label: string): string {
    return ResourceStatus.hoverText(label, !!(side && side.resource_ID),
      this.resourceFor(side && side.resource_ID), side && side.standardized);
  }

  /**
   * Advance whichever stage this side is ready for.
   *
   * `isCover` picks the service; Cover and Body are separate entities
   * with separate endpoints. Draft sides never reach the STANDARDIZE
   * branch because `standardized` is undefined for them, so passing
   * either value is harmless there.
   */
  onResourceBadgeClick(side: any, isCover: boolean, event: Event): void {
    if (event) { event.stopPropagation(); }
    if (!side) { return; }
    const res = this.resourceFor(side.resource_ID);
    const stage = ResourceStatus.action(res, side.standardized);
    if (stage === 'PREPARE') {
      res.prepared = 'WAITING';
      this.resourceService.updateItem(res).subscribe();
    } else if (stage === 'STANDARDIZE') {
      side.standardized = 'WAITING';
      if (isCover) {
        this.coverService.updateItem(side).subscribe();
      } else {
        this.bodyService.updateItem(side).subscribe();
      }
    }
  }

  /**
   * Resolve a Resource, fetching it once if it is not loaded.
   *
   * `requestedResources` guards against a request storm: this runs from
   * template getters on every change-detection pass, so an unguarded
   * `getItem()` would fire one HTTP call per tick until the row landed.
   */
  private resourceFor(resource_ID: number): Resource {
    if (!resource_ID) {
      return null;
    }
    const res = this.resourceService.objects.find(r => r.ID === resource_ID);
    if (!res) {
      if (!this.requestedResources.has(resource_ID)) {
        this.requestedResources.add(resource_ID);
        this.resourceService.getItem(resource_ID).subscribe();
      }
      return null;
    }
    return res;
  }

  getPaperTypeName(paperType_ID: number): string {
    if (!paperType_ID) {
      return '';
    }
    const pt = this.paperTypeService.objects.find(p => p.ID === paperType_ID);
    if (pt) {
      return LanguagePipe.get(pt.name, 'compressSpaces');
    }
    return 'P:' + paperType_ID;
  }

  getLanguageString(value: string): string {
    if (!value) {
      return '';
    }
    return LanguagePipe.get(value, 'compressSpaces');
  }

  isDraftDiff(current: any, nextDraft: any, firstBook: any, draftProp: string, bookProp: string): boolean {
    let previous: any = nextDraft;
    let propToUseForPrevious = draftProp;

    if (!previous) {
      if (firstBook) {
        previous = firstBook;
        propToUseForPrevious = bookProp;
      } else {
        return false;
      }
    }

    const currVal = draftProp.split('.').reduce((acc, part) => acc && acc[part], current);
    const prevVal = propToUseForPrevious.split('.').reduce((acc, part) => acc && acc[part], previous);
    return currVal !== prevVal;
  }

  isDraftDiffPrimary(current: any, nextDraft: any, firstBook: any, draftProp: string, bookProp: string): boolean {
    if (!nextDraft && firstBook) {
      const currVal = draftProp.split('.').reduce((acc, part) => acc && acc[part], current);
      const prevVal = bookProp.split('.').reduce((acc, part) => acc && acc[part], firstBook);
      return currVal !== prevVal;
    }
    return false;
  }

  isDifferent(current: any, previous: any, prop: string): boolean {
    if (!previous) {
      return false; // nothing to compare to
    }
    // deeply compare properties based on string path, e.g. "bindingType" or "draftBody.width"
    const currVal = prop.split('.').reduce((acc, part) => acc && acc[part], current);
    const prevVal = prop.split('.').reduce((acc, part) => acc && acc[part], previous);
    return currVal !== prevVal;
  }
}
